module.exports = __webpack_public_path__ + "static/media/frequency.5b9bc2d9.svg";